export const FETCH = "support.comments.FETCH";
export const FETCH_FAILED = "support.comments.FETCH_FAILED";
export const FETCH_OK = "support.comments.FETCH_OK";

export const CREATE = "support.comments.CREATE";
export const CREATE_FAILED = "support.comments.CREATE_FAILED";
export const CREATE_OK = "support.comments.CREATED";

export const SET_FIELDS = "support.comments.SET_FIELDS";
